import InputMask, { ReactInputMask } from 'react-input-mask';

function ExpirationDateMask(props: Readonly<ReactInputMask>) {
  return <InputMask mask="99/99" {...props} />;
}

export default ExpirationDateMask;
